<div class="popup-content">
    <div class="image-notice">
 
        <i nz-icon nzType="bell" nzTheme="outline" style="color: #dec669;"></i>
    </div>
    <p [innerHTML]="title"></p>
</div>